import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import {
  getOptionsFromRefList,
  generateRules,
  isNonEmptyVariable,
  formatDropDownOptions,
  formatDropDownOptionsWithRefListId,
} from "@/util/common_function";
import { Form } from "antd";
import { forwardRef, useImperativeHandle, useEffect, useState } from "react";
import { useSelector } from "react-redux";

const PlaceBirthForm = forwardRef(
  ({
    formData,
    updateForm,
    bookingsFieldsEnabled,
    personalFormPlaceOfBirthRef,
    startingPoint,
  }) => {
    const { isScheduledBooking } = useSelector((state) => state?.bookings);
    const [form] = Form.useForm();
    const [pobNcicOptions, setPobNcicOptions] = useState();
    const fullSearch = useSelector(state => state.fullSearch);

    useEffect(() => {
      form.setFieldsValue(formData);
    }, [formData]);

    // Expose form methods to parent
    useImperativeHandle(personalFormPlaceOfBirthRef, () => ({
      submitForm: () => form.submit(),
      resetForm: () => form.resetFields(),
      getFormValues: () => form.getFieldsValue(),
      getFieldsError: () => form.getFieldsError(),
      isFieldsValidating: () => form.isFieldsValidating(),
      validateFields: () => form.validateFields(),
    }));

    const handlePobTypeChange = (value) => {
      if (!isNonEmptyVariable(value)) {
        return;
      }
      form.setFieldValue("pobNciCid", null);
      const url = `${API_ENDPOINTS.destinationList}/${value}`;
      api.get(url).then(({ data }) => {
        setPobNcicOptions([]);
        const formattedData = formatDropDownOptionsWithRefListId(data);
        setPobNcicOptions(formattedData);
      });
    };

    return (
      <>
        <Form
          form={form}
          disabled={!bookingsFieldsEnabled}
          initialValues={formData}
          onBlur={() => {
            const values = form.getFieldsValue();
            delete values?.dob;
            delete values?.lastModified;
            updateForm(values);
          }}
        >
          <StyledGridRow gutter={16}>
            <StyledGridCol span={6}>
              <FormItem
                name="fbi"
                label="FBI"
                rules={[
                  {
                    pattern: /^[a-zA-Z0-9]{1,9}$/,
                    message:
                      "The FBI number must be 9 alphanumeric characters or less.",
                  },
                ]}
              >
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={6}>
              <FormItem
                name="sid"
                label="SID"
                rules={[
                  {
                    pattern: /^[a-zA-Z0-9]{1,10}$/,
                    message:
                      "The State ID (SID) field allows alphanumeric characters only and must be 10 characters or less.",
                  },
                ]}
              >
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={6}>
              <FormItem
                name="pobType"
                label="POB Type"
                required={!fullSearch}
                rules={
                  !isScheduledBooking && !fullSearch && startingPoint === "Bookings"
                    ? [
                        {
                          required: true,
                          message: "POB Type is required",
                        },
                      ]
                    : []
                }
              >
                <Select
                  options={getOptionsFromRefList("POBType", false, false, true)}
                  placeholder="POB Type"
                  showSearch={true}
                  variant="outlined"
                  disabled={!bookingsFieldsEnabled}
                  onChange={handlePobTypeChange}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={6}>
              <FormItem
                name="pobNciCid"
                label="POB NCIC"
                required={!fullSearch}
                rules={
                  !isScheduledBooking && !fullSearch && startingPoint === "Bookings"
                    ? [
                        {
                          required: true,
                          message: "POB NCIC is required",
                        },
                      ]
                    : []
                }
              >
                <Select
                  options={
                    Array.isArray(pobNcicOptions)
                      ? pobNcicOptions
                      : getOptionsFromRefList("POBNCIC", false, false, true)
                  }
                  placeholder="POB NCIC"
                  showSearch={true}
                  variant="outlined"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={6}>
              <FormItem
                name="countryOfCitizenshipId"
                label="Country of Citizenship"
                required={!fullSearch}
                rules={
                  !isScheduledBooking && !fullSearch && startingPoint === "Bookings"
                    ? [
                        {
                          required: true,
                          message: "Country of Citizenship is required",
                        },
                      ]
                    : []
                }
              >
                <Select
                  options={getOptionsFromRefList("POBNCIC", false, false, true)}
                  placeholder="Country of Citizenship"
                  showSearch={true}
                  variant="outlined"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={6}>
              <FormItem name="primaryLanguage" label="Primary Language">
                <Select
                  options={getOptionsFromRefList("LanguageList")}
                  placeholder="Primary Language"
                  showSearch={true}
                  variant="outlined"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </Form>
      </>
    );
  }
);
export default PlaceBirthForm;
